import React, { createContext } from "react"
import { Options } from "CryptioUI/types"

export interface ProviderContext {
  open: (message: React.ReactNode, options?: Options) => void
}

// @ts-ignore
export const ToastContext = createContext<ProviderContext>()
